/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { ApiResponse, ApiResponseError, ErrorData } from '../interfaces'
import { ILogin } from '../redux/login'

const sendClientFromMiddleware = async (
  payload: any,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<ILogin | ErrorData>> => {
  try {
    const { data, status } = (await axios({ ...middleware, data: payload })) as AxiosResponse<ILogin>

    return {
      data,
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ApiResponseError>
    const { data, status } = response!

    return {
      data: data.error,
      status,
      success: false,
    }
  }
}

export default sendClientFromMiddleware
